import * as React from "react";
import { hot } from "react-hot-loader";
import { Link } from 'react-router-dom';
import DataProvider from '../../../dataproviders/DataProvider';
import ICandidature from '../../../interfaces/ICandidature';
import EnmUtils from '../../../utils/EnmUtils';
import { ICandidaturesTableProps } from './ICandidaturesTableProps';
import { ICandidaturesTableState } from './ICandidaturesTableState';
declare var libelle: any;
declare var configcustoms: any;

class CandidaturesTable extends React.Component<ICandidaturesTableProps, ICandidaturesTableState> {

    private _dataProvider = new DataProvider();

    constructor(props: ICandidaturesTableProps) {
        super(props);

        this.state = {
            candidaturesPdfIsOnDownload: [],
        };

        this.props.candidaturesList.map((candidature, index) => {
            this.state.candidaturesPdfIsOnDownload[candidature.ID] = false;
        });
    }

    public render() {

        const candidaturesRenderTr = this.props.candidaturesList.map((candidature, index) => {
            const promotionIsClosed = EnmUtils.promotionIsClosed(candidature.IdPromo_x003a_DateFermeture);
            return (
                <tr key={index}>
                    <th scope="row">{candidature.IdPromo_x003a_Titre}</th>
                    <td>{candidature.EtatDepotCandidature}</td>
                    <td>
                        <Link to={configcustoms.Route.Formulaire + '?idCandidature=' + candidature.ID}>
                            {(this.props.EtatDepotCandidatureList[0] === candidature.EtatDepotCandidature &&
                                !promotionIsClosed) &&
                                <span>{libelle.candidaturesTable.edit}</span>
                            }
                            {(this.props.EtatDepotCandidatureList[1] === candidature.EtatDepotCandidature ||
                                promotionIsClosed) &&
                                <span>{libelle.candidaturesTable.show}</span>
                            }
                        </Link>
                    </td>
                    <td className="text-center">
                        <button className="btn btn-primary btn-sm" onClick={this.downloadPdf.bind(this, candidature)}
                            disabled={this.props.EtatDepotCandidatureList[0] === candidature.EtatDepotCandidature || this.state.candidaturesPdfIsOnDownload[candidature.ID]}>
                            <div className="d-flex flex-row">
                                {
                                    this.state.candidaturesPdfIsOnDownload[candidature.ID] &&
                                    <span className="spinner-border spinner-border-sm mr-1 align-self-center" role="status" aria-hidden="true" />
                                }
                                {libelle.candidaturesTable.downloadPdf}
                            </div>
                        </button>
                    </td>
                </tr>
            );
        });

        return (
            <div className="row pt-2">
                <div className="col-12">
                    <h1>{libelle.candidaturesTable.title}</h1>
                    <div className="mt-3 mb-1 custom-card table-responsive">

                        {
                            this.props.candidaturesList.length <= 0 &&
                            <div className="p-4 text-center">{libelle.candidaturesTable.noCandidature}</div>
                        }

                        {
                            this.props.candidaturesList.length > 0 &&
                            <table className="mb-0 table">
                                <thead className="bg-secondary text-white">
                                    <tr>
                                        <th scope="col">{libelle.candidaturesTable.promotionCol}</th>
                                        <th scope="col">{libelle.candidaturesTable.statutCol}</th>
                                        <th scope="col">{libelle.candidaturesTable.detailCol}</th>
                                        <th scope="col" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {candidaturesRenderTr}
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
            </div>
        );
    }

    private downloadPdf(candidature: ICandidature): void {

        this.setState({
            candidaturesPdfIsOnDownload: {
                ...this.state.candidaturesPdfIsOnDownload,
                [candidature.ID]: true
            }
        });
        this._dataProvider.downloadPdfCandidature(this.props.ConnectedLogin, candidature.ID, this.props.categorieList, candidature.NumDossier).then(resp => {
            this.setState({
                candidaturesPdfIsOnDownload: {
                    ...this.state.candidaturesPdfIsOnDownload,
                    [candidature.ID]: false
                }
            });
        });
    }
}

export default hot(module)(CandidaturesTable);
